import React from 'react';
import { Instagram, Facebook } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="py-16 px-8" style={{ backgroundColor: 'var(--atelier-black)' }}>
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="text-2xl tracking-[0.3em] font-light mb-6" style={{ color: 'var(--atelier-gold)' }}>
              PENOTTI ATELIER
            </h3>
            <p className="text-sm leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
              Vakmanschap in elk laagje. Premium Dutch spreads sinds 1970.
            </p>
          </div>

          {/* Collectie */}
          <div>
            <h4 className="text-sm tracking-[0.2em] uppercase mb-6" style={{ color: 'var(--atelier-white)' }}>Collectie</h4>
            <ul className="space-y-3 text-sm" style={{ color: 'var(--atelier-grey)' }}>
              <li>
                <a href="#" className="transition-colors hover:text-[var(--atelier-gold)]">
                  Duo Signatur
                </a>
              </li>
              <li>
                <a href="#" className="transition-colors hover:text-[var(--atelier-gold)]">
                  Uno Signatur
                </a>
              </li>
              <li>
                <a href="#" className="transition-colors hover:text-[var(--atelier-gold)]">
                  Uno Signatur Blanc
                </a>
              </li>
              <li>
                <a href="#" className="transition-colors hover:text-[var(--atelier-gold)]">
                  Limited Editions
                </a>
              </li>
            </ul>
          </div>

          {/* Over */}
          <div>
            <h4 className="text-sm tracking-[0.2em] uppercase mb-6" style={{ color: 'var(--atelier-white)' }}>Over Ons</h4>
            <ul className="space-y-3 text-sm" style={{ color: 'var(--atelier-grey)' }}>
              <li>
                <a href="#" className="transition-colors hover:text-[var(--atelier-gold)]">
                  Ons Verhaal
                </a>
              </li>
              <li>
                <a href="#" className="transition-colors hover:text-[var(--atelier-gold)]">
                  Vakmanschap
                </a>
              </li>
              <li>
                <a href="#" className="transition-colors hover:text-[var(--atelier-gold)]">
                  Ingrediënten
                </a>
              </li>
              <li>
                <a href="#" className="transition-colors hover:text-[var(--atelier-gold)]">
                  Duurzaamheid
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm tracking-[0.2em] uppercase mb-6" style={{ color: 'var(--atelier-white)' }}>Contact</h4>
            <ul className="space-y-3 text-sm" style={{ color: 'var(--atelier-grey)' }}>
              <li>
                <a href="#" className="transition-colors hover:text-[var(--atelier-gold)]">
                  Waar te Koop
                </a>
              </li>
              <li>
                <a href="#" className="transition-colors hover:text-[var(--atelier-gold)]">
                  Contact
                </a>
              </li>
              <li>
                <a href="#" className="transition-colors hover:text-[var(--atelier-gold)]">
                  Recepten
                </a>
              </li>
              <li>
                <a href="#" className="transition-colors hover:text-[var(--atelier-gold)]">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t pt-8 flex flex-col md:flex-row justify-between items-center" style={{ borderColor: 'var(--atelier-charcoal)' }}>
          <p className="text-xs mb-4 md:mb-0" style={{ color: 'var(--atelier-grey)' }}>
            © 2025 Penotti Atelier. Vakmanschap heruitgevonden.
          </p>
          <div className="flex items-center space-x-6">
            <a
              href="#"
              className="transition-colors hover:text-[var(--atelier-gold)]" style={{ color: 'var(--atelier-grey)' }}
            >
              <Instagram size={20} strokeWidth={1.5} />
            </a>
            <a
              href="#"
              className="transition-colors hover:text-[var(--atelier-gold)]" style={{ color: 'var(--atelier-grey)' }}
            >
              <Facebook size={20} strokeWidth={1.5} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;